import { render } from "./BanKiemSoat.vue?vue&type=template&id=6694fc52"
import script from "./BanKiemSoat.vue?vue&type=script&lang=js"
export * from "./BanKiemSoat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__